import React from "react";
import { CodedProperty, ensure } from "sprint-common-web";

import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { RecordType } from "../../../../common/types/RecordType";
import { OrderAssetAvailability } from "../../types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../types/OrderAssetStorageType";
import { AssetsAvailabilityList } from "./AssetsAvailabilityList";

export const renderSubtitlesAvailabilityList = <
    T extends {
        subtitles: {
            availability: OrderAssetAvailability;
            language: CodedProperty;
            isEmbedded?: boolean;
        }[];
        requestedSubTypes?: DynamicSubtitleType[];
    }
>(
    item?: T
): JSX.Element => {
    ensure(item);

    return (
        <AssetsAvailabilityList
            items={item.subtitles}
            type={OrderAssetStorageType.Cloud}
            testId={"order-cloud-subtitles-availability-status"}
            assetType={RecordType.Subtitle}
            requiredSubtitleTypes={item.requestedSubTypes}
        />
    );
};
